import { Route } from '@angular/router';
import { LayoutComponent, PageLayoutComponent } from '@ledgerly/shared/layout';
import { LandingPageComponent } from '@ledgerly/landing/page';
import { appResolver } from './app.resolver';

export const appRoutes: Route[] = [
  {
    path: '',
    resolve: { app: appResolver },
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: LandingPageComponent,
      },
    ],
  },
  {
    path: '',
    resolve: { app: appResolver },
    component: PageLayoutComponent,
    children: [
      // Two free tools that answer the questions the landing page raises:
      // "how much can I spend per day" and "how is that worked out". English
      // slugs in every locale, so `StaticPageSeoService` can build one
      // hreflang cluster per page from the route alone.
      {
        path: 'daily-budget-calculator',
        loadComponent: () =>
          import('@ledgerly/landing/tools').then(
            (m) => m.CalculatorPageComponent
          ),
      },
      {
        path: 'safe-to-spend-formula',
        loadComponent: () =>
          import('@ledgerly/landing/tools').then(
            (m) => m.FormulaPageComponent
          ),
      },
      {
        path: 'terms',
        loadComponent: () =>
          import('@ledgerly/pages/terms').then((m) => m.TermsComponent),
      },
      {
        path: 'facts',
        loadComponent: () =>
          import('@ledgerly/pages/terms').then((m) => m.FactsComponent),
      },
      {
        path: 'privacy',
        loadComponent: () =>
          import('@ledgerly/pages/terms').then((m) => m.PrivacyComponent),
      },
      // The blog. Individual post routes are not listed here or anywhere
      // else in code: they come from content/blog, through the per-locale
      // prerender routes file that `nx run landing-blog:content` writes.
      // Publishing a post is one .md file and a commit.
      //
      // `loadChildren` rather than `loadComponent` because the two pages come
      // with resolvers, and the body of a post has to be resolved during the
      // navigation for it to reach the prerendered HTML.
      {
        path: 'blog',
        loadChildren: () =>
          import('@ledgerly/landing/blog').then((m) => m.blogRoutes),
      },
    ],
  },
];
